import { Resource } from 'kolibri/apiResource';

export default new Resource({
  name: 'facility',
});
